import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';

import { getPrioritizedConnectionConfig } from '../../services/connections';
import useNavigation from '../../hooks/useNavigation';
import useUserPermissions from '../../hooks/useUserPermissions';
import DisabledPage from 'pages/DisabledPage';

const PrivateRoutes = ({ children, title, ...rest }) => {
    const isAuthenticated = useIsAuthenticated();
    const location = useLocation();
    const { isAdmin, isInternalAdmin } = useUserPermissions();
    const { isAdminRoute, isInternalAdminRoute, isDisabledRoute, isTopMenuFetched } = useNavigation();

    if (isAuthenticated) {
        if (location.pathname === '/connection') {
            return <Outlet />;
        }

        const connectionConfig = getPrioritizedConnectionConfig();

        if (!connectionConfig) {
            if (location.pathname === '/environment' || location.pathname === '/book') {
                return <Outlet />;
            }

            return <Navigate to="/connection" />;
        }

        if (!isTopMenuFetched) {
            return null;
        }

        if (!isAdmin && isAdminRoute(location.pathname)) {
            return <Navigate to="/" />;
        }

        if (!isInternalAdmin && isInternalAdminRoute(location.pathname)) {
            return <Navigate to="/" />;
        }

        if (isDisabledRoute(location.pathname)) {
            return <DisabledPage />;
        }

        return <Outlet />;
    } else {
        return <Navigate to={`/login${window.location.search}`} replace />;
    }
};

export default PrivateRoutes;
